import { BillingSettingAPI } from "../api";
import { AccountingProduct } from "../classes"
export class BillingSetting {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
    this.typeString = ""
    if (data.type == "monthly") {
      this.typeString = "รายเดือน"
    } else if (data.type == "quantity") {
      this.typeString = "ต่อหน่วย"
    } else if (data.type == "day_of_month") {
      this.typeString = "คูณจำนวนวันในเดือน"
    } else if (data.type == "minimum_unit") {
      this.typeString = "คิดตามจริง ขั้นต่ำเป็นยูนิต"
    } else if (data.type == "minimum_cost") {
      this.typeString = "คิดตามจริง บวกส่วนต่างจากราคาขั้นต่ำ"
    } else if (data.type == "monthly_square_metre") {
      this.typeString = "คิดตามตารางเมตร ต่อเดือน"
    } else if (data.type == "day_of_month_square_metre") {
      this.typeString = "คิดตามตารางเมตร คูณจำนวนวันในเดือน"
    } else if (data.type == "step") {
      this.typeString = "คิดแบบอัตราก้าวหน้า"
    }
    this.accountingProduct = new AccountingProduct(data.accountingProduct)
  }
  static async getBillingSettingsByAreas(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByAreas(payload);
    return data.result.map((item) => new BillingSetting(item));
  }
  static async getBillingSettingsByIncludeArea(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByIncludeArea(payload);
    // Array Return
    data.result.map((item) => new BillingSetting(item));
    // Object Return
    // data.result = new BillingSetting(data.result)
    return data.result;
  }
  static async getBillingSettingsByMeters(payload) {
    const { data } = await BillingSettingAPI.getBillingSettingsByMeters(payload);

    return data.result.map((item) => new BillingSetting(item));
  }
  static async getBillingSettings(payload) {
    const { data } = await BillingSettingAPI.getBillingSettings(payload);
    return data.result.map(item => (item = new BillingSetting(item)));
  }
  static async createBillingSetting(payload) {
    const { data } = await BillingSettingAPI.createBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async removeBillingSetting(payload) {
    const { data } = await BillingSettingAPI.removeBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async removeBillingSetting(payload) {
    const { data } = await BillingSettingAPI.removeBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async updateBillingSetting(payload) {
    const { data } = await BillingSettingAPI.updateBillingSetting(payload);
    let billingSetting = new BillingSetting(data.result);
    return billingSetting
  }
  static async getBillingSettingsByIds(ids) {
    const { data } = await BillingSettingAPI.getBillingSettingsByIds(ids);
    return data.result.map(item => (item = new BillingSetting(item)));
  }
}
